import React from 'react';

interface ProjectFiltersProps {
  categories: { id: number; name: string }[];
  selectedCategory: number | null;
  onSelectCategory: (id: number | null) => void;
  onReset: () => void;
  filtersLabel: string;
  resetLabel: string;
}

const SELECTED_COLOR = '#330052';

const ProjectFilters: React.FC<ProjectFiltersProps> = ({
  categories,
  selectedCategory,
  onSelectCategory,
  onReset,
  filtersLabel,
  resetLabel,
}) => (
  <div className="flex items-center justify-between mb-8">
    {/* Catégories : scrollable sur mobile, wrap sur desktop */}
    <div className="flex-1 relative">
      <div className="flex gap-2 flex-nowrap items-center
        overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300
        scrollbar-track-transparent sm:flex-wrap sm:overflow-x-visible">
        
        {/* Bouton "Tous" */}
        <button
          key="all"
          className={`cursor-pointer relative px-2 py-1 font-medium
            transition-colors duration-200 whitespace-nowrap ${
              selectedCategory === null ? '' : 'text-gray-700 hover:text-[#ffd900]'
            }`}
          style={{
            background: 'none',
            border: 'none',
            color: selectedCategory === null ? SELECTED_COLOR : undefined,
          }}
          onClick={() => onSelectCategory(null)}
        >
          <span className="relative">
            Tous
            <span
              className={`absolute left-0 -bottom-0.5 w-full h-0.5
                rounded transition-all duration-300 ${
                  selectedCategory === null ? 'scale-x-100' : 'scale-x-0'
                }`}
              style={{
                backgroundColor: SELECTED_COLOR,
                transformOrigin: 'left',
                transitionProperty: 'transform, background-color',
                transform: selectedCategory === null ? 'scaleX(1)' : 'scaleX(0)',
              }}
            />
          </span>
        </button>

        {/* Autres catégories */}
        {categories.map((cat) => (
          <button
            key={cat.id}
            className={`cursor-pointer relative px-2 py-1 font-medium
              transition-colors duration-200 whitespace-nowrap ${
                selectedCategory === cat.id ? '' : 'text-gray-700 hover:text-[#ffd900]'
              }`}
            style={{
              background: 'none',
              border: 'none',
              color: selectedCategory === cat.id ? SELECTED_COLOR : undefined,
            }}
            onClick={() => onSelectCategory(cat.id)}
          >
            <span className="relative">
              {cat.name}
              <span
                className={`absolute left-0 -bottom-0.5 w-full h-0.5
                  rounded transition-all duration-300 ${
                    selectedCategory === cat.id ? 'scale-x-100' : 'scale-x-0'
                  }`}
                style={{
                  backgroundColor: SELECTED_COLOR,
                  transformOrigin: 'left',
                  transitionProperty: 'transform, background-color',
                  transform: selectedCategory === cat.id ? 'scaleX(1)' : 'scaleX(0)',
                }}
              />
            </span>
          </button>
        ))}

        {/* Bouton reset inline sur mobile, masqué sur desktop */}
        <button
          className="cursor-pointer flex items-center justify-center
            flex-shrink-0 px-2 py-2 rounded-full border border-[1px]
            transition-transform duration-150 shadow-sm bg-white sm:hidden
            absolute top-1/2 right-0 -translate-y-1/2 mr-2"
          style={{
            color: '#330052',
            borderColor: '#330052',
            boxShadow: '0 1px 4px 0 rgba(51,0,82,0.08)',
          }}
          onMouseDown={(e) => e.currentTarget.classList.add('scale-95')}
          onMouseUp={(e) => e.currentTarget.classList.remove('scale-95')}
          onMouseLeave={(e) => e.currentTarget.classList.remove('scale-95')}
          onClick={onReset}
          title={resetLabel}
        >
          <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 20 20">
            <line x1="5" y1="5" x2="15" y2="15" strokeWidth="2" strokeLinecap="round" />
            <line x1="15" y1="5" x2="5" y2="15" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      </div>
    </div>

    {/* Bouton reset à droite sur desktop, masqué sur mobile */}
    <div className="hidden sm:flex items-center justify-center ml-2">
      <button
        className="cursor-pointer flex items-center px-3 py-2
          rounded-full border border-[1px] transition-transform duration-150
          shadow-sm bg-white"
        style={{
          color: '#330052',
          borderColor: '#330052',
          boxShadow: '0 1px 4px 0 rgba(51,0,82,0.08)',
        }}
        onMouseDown={(e) => e.currentTarget.classList.add('scale-95')}
        onMouseUp={(e) => e.currentTarget.classList.remove('scale-95')}
        onMouseLeave={(e) => e.currentTarget.classList.remove('scale-95')}
        onClick={onReset}
        title={resetLabel}
      >
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 20 20">
          <line x1="5" y1="5" x2="15" y2="15" strokeWidth="2" strokeLinecap="round" />
          <line x1="15" y1="5" x2="5" y2="15" strokeWidth="2" strokeLinecap="round" />
        </svg>
        <span className="ml-1 text-base align-middle">{resetLabel}</span>
      </button>
    </div>
  </div>
);

export default ProjectFilters;
